/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import json_temp from "../Templates/json_temp";
import ticket_temp from "../Templates/ticket_temp";
import email_temp from "../Templates/email_temp";
import db_temp from "../Templates/db_temp";
import document_temp from "../Templates/document_temp";
import table_temp from "../Templates/table_temp";
import bot_temp from "../Templates/bot_temp";

import JSONAvatar from "../Avatars/JSONAvatar";
import EMAILAvatar from "../Avatars/EMAILAvatar";
import SMAvatar from "../Avatars/SMAvatar";
import DBAvatar from "../Avatars/DBAvatar";
import DOCUMENTAvatar from "../Avatars/DOCUMENTAvatar";
import TABLEAvatar from "../Avatars/TABLEAvatar";
import BOTAvatar from "../Avatars/BOTAvatar";
import DATAAvatar from "../Avatars/DATAAvatar";
import data_temp from "../Templates/data_temp";

let viewer_map = [
  {
    type: ["UNKNOWN"],
    sub_type: ["unknown"],
    viewer: "json",
    template: json_temp,
    avatar: JSONAvatar,
    drl_required: false,
  },
  {
    type: ["SM"],
    sub_type: ["sm"],
    viewer: "ticket",
    template: ticket_temp,
    avatar: SMAvatar,
    drl_required: false,
  },
  {
    type: ["EMAIL"],
    sub_type: ["exchange", "imap"],
    viewer: "email",
    template: email_temp,
    avatar: EMAILAvatar,
    drl_required: false,
  },
  {
    type: ["DATA"],
    sub_type: [
      "pdf",
      "ppt",
      "pptx",
      "doc",
      "docx",
      "txt",
      "html",
      "xls",
      "xlsx",
      "csv",
      "bmp",
      "pbm",
      "pgm",
      "ppm",
      "sr",
      "ras",
      "jpeg",
      "jpg",
      "jpe",
      "jp2",
      "tiff",
      "tif",
      "png",
    ],
    viewer: "data",
    template: data_temp,
    avatar: DATAAvatar,
    drl_required: true,
  },
  {
    type: ["TABLE"],
    sub_type: ["xls", "xlsx", "csv"],
    viewer: "table",
    template: table_temp,
    avatar: TABLEAvatar,
    drl_required: true,
  },
  {
    type: ["DB"],
    sub_type: ["sql", "nosql"],
    viewer: "database",
    template: db_temp,
    avatar: DBAvatar,
    drl_required: false,
  },
  {
    type: ["BOT"],
    sub_type: ["script"],
    viewer: "bot",
    template: bot_temp,
    avatar: BOTAvatar,
    drl_required: false,
  },
];

export default viewer_map;
